import axios from 'axios'
import { configEnv } from '@/configEnv'
import { useUserStore } from '@/store/user'

const instance = axios.create({
  baseURL: configEnv.api.url,
})

// 요청 바로 직전
function preRequest(config) {
  const userStore = useUserStore()
  if (userStore.getToken) {
    config.headers['EZTOBIZ-AUTH-TOKEN'] = userStore.getToken
  }
  if (config.url === '/user/login' || config.url === '/user/userIdFind' || config.url === '/user/userPasswordFind' || config.url === '/user/userPasswordChange'|| config.url === '/user/passwordChange') {
    config.baseURL = configEnv.api.authUrl
  }
  return config
}

function reqErrorHandler(error) {
  return Promise.reject(error)
}

function preResponse(response) {
  return response
}

function resErrorHandler(error) {
  if (error && error.response && error.response?.data) {
    if (error.response.data?.code == '0401') {
      const userStore = useUserStore()
      alert(error.response.data?.message)
      userStore.setUser(null)
      location.href = '/login'
      return
    }
  }
  return Promise.reject(error)
}


// interseptors
instance.interceptors.request.use(preRequest, reqErrorHandler)
instance.interceptors.response.use(preResponse, resErrorHandler)

const { get, post, put } = instance
export { get, post, put }
